import { useMemo } from "react"

import useQuestBoardStore from "./useQuestBoardStore"
import { useFamilyQuery, useQuestBoardQuery } from "../../networking/queries"
import { FamilyQuerySelect, UserSelectFilterType } from "../../types"

const useQuestBoardFilters = () => {
  const { data } = useQuestBoardQuery()
  const { data: children } = useFamilyQuery(FamilyQuerySelect.CHILDREN)
  const { selectedFilterType, selectedUserId, selectedRoutine } =
    useQuestBoardStore()

  const filteredQuests = useMemo(() => {
    return (
      data?.filter((quest) => {
        // Filter quests by select option
        if (selectedFilterType === UserSelectFilterType.ALL_KIDS) {
          return children?.some((child) => child.user.id === quest.user_id)
        }

        // Filter quests by child
        if (selectedUserId && quest.user_id !== selectedUserId) {
          return false
        }
        // Filter quests by routine
        if (selectedRoutine && quest.series.routine !== selectedRoutine) {
          return false
        }
        return true
      }) || []
    )
  }, [data, children, selectedFilterType, selectedUserId, selectedRoutine])

  return { filteredQuests }
}

export default useQuestBoardFilters
